
import { Vue, Component } from "vue-property-decorator";
import AppBar from "./common/AppBar.vue";

@Component({
  components: { AppBar },
})
export default class DefaultLayout extends Vue {}
